// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2dLiu","header":"Messages_header__1CX2y"};